import Settings from 'src/Settings';
import faqConfig, {FAQ} from './faqConfig';

export const getFAQsByStrategy = (): FAQ[] => {
  if (Settings.isAramark()) return faqConfig.aramark();
  if (Settings.is365Pay()) return faqConfig.pay365();
  if (Settings.isRefive()) return faqConfig.refive();
  if (Settings.buildType === 'canteen' && Settings.isNewUI())
    return faqConfig.canteen();
  return faqConfig.default();
};
